import { render, staticRenderFns } from "./CommentsTest.vue?vue&type=template&id=15ac9f8a&scoped=true"
import script from "./CommentsTest.vue?vue&type=script&lang=js"
export * from "./CommentsTest.vue?vue&type=script&lang=js"
import style0 from "./CommentsTest.vue?vue&type=style&index=0&id=15ac9f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac9f8a",
  null
  
)

export default component.exports